import React, { useCallback } from 'react';
import { ALIGN_TYPE } from '@zmedia/bm-soccer-ui/constants';
import { IBaseSection, IContent } from '@zmedia/bm-soccer-ui/interface';
import ContentList from '@zmedia/bm-soccer-ui/modules/content/components/list';
import { InfiniteList } from '@zmedia/bm-soccer-ui/modules/shared/components/InfiniteList';
import Empty from '@zmedia/bm-soccer-ui/modules/shared/components/Empty';
import { ContentService } from '@zmedia/bm-soccer-ui/service/ContentService';
import { Section } from '@zmedia/bm-soccer-ui/components';

interface IProps extends IBaseSection<IContent> {
    className?: string;
    alignList?: ALIGN_TYPE;
    alignItem?: ALIGN_TYPE;
    hasLayoutPhoto?: boolean;
    ComponentList?: React.FunctionComponent<any>;
    ComponentListProps?: any;
    ComponentEmpty?: React.FunctionComponent<any>;
    title?: string;
    children?: React.ReactNode;
    showSapo?: boolean;
    name?: string;
    listProps?: any;
}

export default React.memo(function ContentMoreSection(props: IProps) {
    const {
        items = [],
        className = '',
        name = '',
        alignList,
        alignItem,
        hasLayoutPhoto = true,
        displayTimeIn,
        ComponentList = ContentList,
        ComponentEmpty = Empty,
        tracking,
        options = {},
        title = '',
        children,
        showSapo,
        listProps,
    } = props;

    const fetchFn = useCallback(
        (page: number): Promise<any> => {
            let params = options?.params || {};
            params.page = page || 1;
            return ContentService.getList(options?.url, params);
        },
        [options.url]
    );
    
    const ListProps = {
        ComponentList,
        ComponentEmpty,
        ComponentListProps: {
            align: alignList,
            alignItem: alignItem,
            hasLayoutPhoto,
            displayTimeIn,
            tracking,
            showSapo: showSapo,
            ...listProps,
        },
        fetchFn: fetchFn,
        items: items,
        currentPage: options?.params?.page,
    };

    return (
        <Section className={className} name={name}>
            {children}
            <InfiniteList {...ListProps} className={className} title={title} />
        </Section>
    );
});
